<ul class="lang-switcher lang-switcher-{{ type }} inline-block relative">
  <li *ngFor="let language of languages" class="item inline-block z-10 {{ lang === language ? 'active' : 'inactive' }}">
    <span (click)="switchLang(language)">
      {{ language | uppercase }}
    </span>
  </li>
</ul>
